import { LogMealType } from "model/food/types/base.types"
import CustomDropdown from "components/inputs/CustomDropdown"
import { logMealTypeOptions } from "../PageTitleMealTypeSelection"
import { useState } from "react"
import { MealTypeValueBox, MealTypeValue } from "./styled"
import { capitalizeFirstLetter } from "utils/formater"

const DropdownDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M9.26822 11.0781C8.86843 11.5579 8.13157 11.5579 7.73178 11.0781L4.18341 6.82009C3.91202 6.49443 4.1436 6 4.56752 6H12.4325C12.8564 6 13.088 6.49443 12.8166 6.82009L9.26822 11.0781Z"
      fill="white"
    />
  </svg>
)

const FoodDetailsMealTypeSelection = ({
  value,
  onChange,
}: {
  value?: LogMealType
  onChange: (nextVal?: LogMealType) => void
}) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false)

  const displayValue = value
    ? capitalizeFirstLetter(value.toLowerCase())
    : "Meal type"

  return (
    <CustomDropdown
      value={value?.toLowerCase()}
      groupItems={[logMealTypeOptions]}
      onChange={(nextValue) => {
        onChange(nextValue?.toUpperCase())
      }}
      onVisibleChange={setIsPopoverVisible}
    >
      <MealTypeValueBox $isActive={isPopoverVisible}>
        <MealTypeValue $hasValue={!!value}>{displayValue}</MealTypeValue>
        <DropdownDownIcon />
      </MealTypeValueBox>
    </CustomDropdown>
  )
}

export default FoodDetailsMealTypeSelection
